import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges, TemplateRef } from '@angular/core';
import { DocumentService } from 'src/app/services/operations/document.service';
import { DocumentGenService } from 'src/app/services/DocumentGen/documentGen.services';
import { ToastrService } from 'ngx-toastr';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';
import { UserSessionService } from 'src/app/services/usersession.service';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { PaymentService } from 'src/app/services/payment.service';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { IProspectContactInfo } from '../models/ProspectModel';
import { EmailAndSMSService } from 'src/app/services/operations/EmailAndSMS.service';
import { NgForm, FormControl, Validators, FormBuilder, AbstractControl, FormGroup } from '@angular/forms';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { ETransactionTypes, ELetterAndNoticesTemplates, ECallScriptSections } from '../enum';
import { IInternetSettings } from '../interface';
import { FacilityService } from 'src/app/services/facility.service';
import { UnsignedDocumentsService } from 'src/app/services/unsigned-documents.service';
import { ISendEmailOutput, ISendEmailOutputModel, ISendSmsResponse } from '../interface2';
import { IReportResponse } from '../models/ReportsModel';
import { ReportsService } from 'src/app/services/operations/reports.service';
import { GeneralService } from 'src/app/services/general.service';
import { DatePipe } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { ThumbSettings } from '@syncfusion/ej2-angular-charts';
import { ESignatureService } from 'src/app/add-ons/esignature/esignature.service';
import { HttpStatusCode } from '@angular/common/http';
import { CallScriptService } from 'src/app/services/call-script.service';
import { ipv4 } from "getipify";
import { MediaMatcher } from '@angular/cdk/layout';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import{interval} from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
    selector: 'app-document-shared',
    templateUrl: './document-shared.component.html',
    styleUrls: ['./document-shared.component.scss'],
    standalone: false
})
export class DocumentSharedComponent implements OnInit {
  section = ECallScriptSections.Documents;
  @Input() displayCallScript = false;

  onApproveFlag = false;
  onEmailFlag = false;
  onSmsFlag = false;
  manualInvoiceGenerated = false;
  subjectProcess: Subject<any> = new Subject();
  subjectProcessAll: Subject<any> = new Subject();
  selectedEmailTemplate = null;
  selectedSMSTemplate = null;
  IPAddress: string = '';
  reportUrl;
  companySettingDetails: any;
  emailAndSmsBox: string = ''; 
  emailAndSmsBoxPhoneNumber;
  @Input() emailAddress = '';
  @Input() customerInfo;
  @Input() isOneLocal = false;
  @Input() lettersList = [];
  @Input() defaultDocList = [];
  dropdownLettersList = [];
  private documentsInitialized = false;
  private boundDefaultDocuments = new Map<string, number>();
  private welcomeLetterId: number;
  @Input() emailTemplates = [];
  @Input() smsTemplates = [];
  @Input() facilityId;
  @Input() tenantId;
  @Input() periodFromDateLedger;
  @Input() periodFromDateNotes;
  @Input() leaseNo;
  @Input() transferedOutLeaseNo;
  @Input() NoentriesforLeaseAgreement;
  @Input() transactionType;
  @Input() RentRaiseId;
  @Input() paidThruDate = new Date();
  @Input() unitNum;
  @Input() payModeId;
  @Input() ReservationNumber;
  @Input() receiptId;
  @Input() isfromModifyRental: Boolean = false;
  @Input() isFromRentRaise: Boolean = false;
  @Input() isfromTransfer: Boolean = false;
  @Input() isfromAuctionManage: Boolean = false;
  @Input() IsfromBatchRentRaise: Boolean = false;
  @Input() isfrombatchletters: Boolean = false;
  @Input() isfrommodifyTenantInfo: Boolean = false;
  @Input() IsFromManualInvoice: Boolean = false;
  @Input() moveInSettings;
  @Input() miscellaneousSettings;
  @Input() ResreceiptNumber;
  @Input() proAuctionAmtDue;
  @Input() proAuctionProceed;
  @Input() isExemptFromSendingDetailsToOneLocal = false;
  @Input() RegenerationofReceipt = false;
  @Output() emitgoToHost: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitgoToHostforEditInfoDoc: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitMailPrint: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('documentPopup', { static: true }) documentPopup: ModalDirective;
  @ViewChild('OneLocalPopup', { static: true }) OneLocalPopup: TemplateRef<any>;
  @ViewChild('printPreviewPopup', { static: true }) printPreviewPopup: ModalDirective;
  @ViewChild('EsignatureModal', { static: true }) esignatureModal: TemplateRef<any>;
  @ViewChild('documentemailsmspopup', { static: true }) documentemailsmspopup: TemplateRef<any>;
  modalConfig = {
  backdrop: 'static'
};
  modalRef?: BsModalRef;
  emailsmsmodalRef?:BsModalRef; 
  mdq: MediaQueryList;
  documentList = [];
  loaderIcon: Promise<boolean>;
  unitInfoLoader: Promise<boolean>;
  @ViewChild('printform', { static: true }) printform: NgForm;
  emailPattern = '^([\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)([\,\;]{1}[\\wÀ-ŸØ-öø-ÿ]+[\\wÀ-ŸØ-öø-ÿ!#$%?^&*+-=]*\\@[\\wÀ-ŸØ-öø-ÿ\-]+(?:\\.[\\wÀ-ŸØ-öø-ÿ]{2,}[\\wÀ-ŸØ-öø-ÿ]*)+)*$';
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  emailCheckBox;
  emailCheckBoxDoc;
  selectedDocItem: any;
  enableEmail = false;
  enablesms = false;
  emailBox = '';
  phoneNumber;
  sendSMSAlert:boolean = false;
  emailarray = [];
  totalmailresponse: string;
  isPrintChecked: boolean = false;
  isSMSChecked: boolean = false;
  isSMSCheckedDoc: boolean = false;
  isSmsDisabled: boolean = true;
  emailAndSmsflag: boolean = false;
  // E-Signature
  connection: signalR.HubConnection;
  private appBaseUrl = environment.appBaseUrl;
  currentUserId: number;
  slNumber: any;
  messageBody: any;
  btndisable: boolean = false;
  SendDetailsToOneLocal = false;
  notesOneLocalCancel = '';
  tempfacilityInternetSettings: IInternetSettings;
  modalRefOneLocal: BsModalRef;
  modalRefNotesOneLocal: BsModalRef;
  unSingedDocuments = [];
  pageModel = {
    PageCount: 0,
    PageSize: 500
  }
  private apiBaseUrl = this.appService.config.apiBaseUrl;
  // @ViewChild('defaultRTE', /* TODO: add static flag */ null)
  public toolbarConfig: object = {
    items: ['Undo', 'Redo', '|',
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'SubScript', 'SuperScript', '|',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink',
      'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  };
  emailfullContent: ISendEmailOutputModel;
  rteValue: any;
  currentSubject: string;
  currentDocument: any;
  sendEmailForm: FormGroup;
  leaseBloBURLs = [];
  leaseDocumentResponse = [];
  disableSelectAll: boolean = false;
  selectAllCB: boolean = false;
  bulkProcess: boolean = false;
  tenantLettersAndNoticesIdsForEsignature = [];
  public PhoneNumberMask: String = '(000)000-0000';
  signatureDocumentCount: number = 0;
  totalSignatureDocumentCount: number = 0;
  isDocGenerationfailed: boolean = false;
  isCallCenterGroup: boolean = false;
  eSignatureType = 563;
  eSignatureIds = [];
  documentResponse: any;
  isWalkInCustomer;
  ReputationActive: boolean = false;
  private apiStatusInterval = environment.paymentGetCCTStatusInterval;
  private apiMaxWaitTime = environment.paymentMaxWaitTime;
  duplicateDocumentRequestList = [];
  tenantDocumentDetails: any;
  isDocumentDownload = false;
  countryCode;
  fullNumber;
  constructor(private documentService: DocumentService,
    private documentGenService: DocumentGenService,
    private userSessionService: UserSessionService,
    private toaster: ToastrService,
    private facOpsDataService: FacOpsDataService,
    private data: DataService,
    private prospectsService: ProspectService,
    private paymentService: PaymentService,
    private emailAndSmsService: EmailAndSMSService,
    private unSingedDocumentService: UnsignedDocumentsService,
    private customerService: CustomerService,
    private storeService: FacilityService,
    public modalService: BsModalService,
    private reportService: ReportsService,
    private generalService: GeneralService,
    private appService: AppService,
    private fb: FormBuilder,
    private esignatureService: ESignatureService,
    public media: MediaMatcher,
    private twoWayService: twoWayService,
    private customerDataService: CustomerDataService,
    ) { }

  ngOnInit() {
    this.bulkProcess = false;
    this.sendEmailForm = this.fb.group({
      'toAddress': ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      'ccAddress': ['', [Validators.pattern(this.emailPattern)]]
    });
    this.getESignatureType();
    if(this.displayCallScript) {
      this.facOpsDataService.setCurrentType(this.section, true);
      this.facOpsDataService.isScriptDataPresent(this.section, false, false, false);
    }   
    if (this.isOneLocal === true) {
      this.getFacilityInternetSettings(this.facilityId);
    }
    this.printform.form.addControl('email', new FormControl(Validators.pattern(this.emailPattern)));    
    this.bindDefaultDocList();
    this.documentsInitialized = true;
    if (this.transactionType == 4 || this.isfromAuctionManage) {
      this.getReportUrl();
    }
    this.currentUserId = this.userSessionService.userSessionData.UserId;
    this.getResposeFromESignature();

    this.setEmailIdAndCellPhoneNumber();
    this.getIpAddress();

    this.documentList.map(ele => {
      if (ele.isDocumentSuccess || ele.isDocumentFailed) {
        ele['select'] = true;
        ele['disableSelect'] = true;
      } else {
        ele['select'] = false;
        ele['disableSelect'] = false;
      }
    });
    if (this.emailTemplates.length) {
      if (this.emailTemplates.some((ele) => ele.DefaultTemplate)) {
        this.selectedEmailTemplate = this.emailTemplates.find((item) => item.DefaultTemplate).LetterId;
      } else {
        this.selectedEmailTemplate = this.emailTemplates[0].LetterId;
      }
    }
    if (this.smsTemplates.length) {
      if (this.smsTemplates.some((ele) => ele.DefaultTemplate)) {
        this.selectedSMSTemplate = this.smsTemplates.find((item) => item.DefaultTemplate).LetterId;
      } else {
        this.selectedSMSTemplate = this.smsTemplates[0].LetterId;
      }
    }

    if (this.isfrombatchletters && this.documentList.every((item) => item.select)) {
      this.selectAllCB = true;
      this.disableSelectAll = true;
    }
    this.subjectProcess.pipe(debounceTime(100)
      ,distinctUntilChanged())
      .subscribe(val => {
        this.processDocument(val);
      });
    this.subjectProcessAll.pipe(debounceTime(100)
      ,distinctUntilChanged())
      .subscribe(val => {
        this.processAll();
      });
    if (this.userSessionService) {
      this.isCallCenterGroup = this.userSessionService.isCallcenterAgent === true ? true : false;
    }
    if (this.customerDataService.CustomerInfoList) {
    this.countryCode = this.customerDataService.CustomerInfoList.CountryCode;
    } 
  }
  
  ngOnDestroy() {
    if (this.duplicateDocumentRequestList.length > 0) {
      for (const subscriptionModel of this.duplicateDocumentRequestList) {
        subscriptionModel.Subscription.unsubscribe();
      }
    }
  }

  addNewDocument() {
    let obj = {
      slNo: this.getLargestNum(),
      TemplateId: 0,
      Processed: false,
      LetterId: 0,
      obtainSignature: false,
      blobUrl: '',
      isDefault: false,
      isEmail: true,
      isEmailTemplateDefined: true,
      isSMSTemplateDefined: true,
      isApprove: true,
      isEmailSuccess: false,
      isSmsSuccess: false,
      isDocumentSuccess: false,
      isDocumentFailed: false,
      select: false,
      LetterName: "Select"
    };
    this.documentList.push(obj);
  }

  removeDocument() {
    if (this.documentList.length) {
      let slNo = this.getLargestNum() - 1;
      let index = this.documentList.findIndex(o => o.slNo === slNo);
      let docObj = this.documentList[index];
      if (docObj) {
        let docIndex = this.defaultDocList.findIndex(o => o.LetterId == docObj.LetterId);
        if (docIndex === -1 && docObj.LetterId != this.welcomeLetterId) {
          this.documentList.splice(index, 1);
          this.boundDefaultDocuments.forEach((boundSlNo, identity) => {
            if (boundSlNo === docObj.slNo) {
              this.boundDefaultDocuments.delete(identity);
            }
          });
        }
      }
    }
  }

  bindDefaultDocList() {
    const firstNewRow = this.documentList.length;
    if (this.defaultDocList.length) {
      this.defaultDocList.forEach((ele) => {
        let letterObj;
        let obj;
        if (this.lettersList.length) {
          letterObj = this.lettersList.find(o => o.LetterId == ele.LetterId);
          if (letterObj) {
            const identity = this.getDefaultDocumentIdentity(ele, letterObj);
            if (this.boundDefaultDocuments.has(identity)) {
              return;
            }
            if (this.isFromRentRaise) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                InsType: false,
                SSType: false,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                RentRaiseId: ele.RentRaiseId,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              }
            } else if (this.isfromModifyRental) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                InsType: false,
                SSType: false,
                AutoCC: false,
                AutoACH: false,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                transactionType: letterObj.transactionType,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : '',
                LinkedLeaseNo : ele.LinkedLeaseNo
              }
              if (obj.TemplateId === ELetterAndNoticesTemplates.Insurance_Cancellation_Letter || obj.TemplateId === ELetterAndNoticesTemplates.Insurance_Addendum) {
                obj.InsType = true;
              } else if (obj.TemplateId == ELetterAndNoticesTemplates.Refund_Voucher) {
                obj.SSType = true;
              } else if (obj.TemplateId == ELetterAndNoticesTemplates.Automatic_Credit_Card_Form) {
                obj.AutoCC = true;
              } else if(obj.TemplateId == ELetterAndNoticesTemplates.Automatic_ACH_Form) {
                obj.AutoACH = true;
              }
            } else if (this.IsfromBatchRentRaise) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                leaseNo: ele.leaseId,
                RentRaiseId: ele.RentRaiseId,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != ''  ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              }
            } else if (this.isfrombatchletters) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                leaseNo: ele.leaseId,
                tenantId: ele.TenantId,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: ele.isDocumentSuccess,
                isDocumentFailed: ele.isDocumentFailed,
                isAlternateBlobPresent: ele.isAlternateBlobPresent,
                alternateBlobUrl: ele.alternateBlobUrl,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              }
            } else if (this.isfrommodifyTenantInfo) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                leaseNo: ele.leaseNo,
                facilityId: ele.FacilityId,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != ''  ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              }
            } else if (this.transactionType === 43) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                ReceiptId: ele.RecepitNumber,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                leaseNo: ele.leaseId,
                facilityId: this.facilityId ? this.facilityId : ele.FacilityId,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                TenantEmail : ele.TenantEmail,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              }
            } else if (this.isfromTransfer) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                ReceiptId: letterObj.RecepitNumber,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: 389,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : '',
                LinkedLeaseNo : ele.LinkedLeaseNo
              };
            }
            else if (this.isfromAuctionManage) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                ReceiptId: letterObj.RecepitNumber,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: 389,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              };
            } else if (this.IsFromManualInvoice) {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                ReceiptId: letterObj.RecepitNumber,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                isEmail: letterObj.ObtainSignature ? true : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: false,
                isDocumentFailed: false,
                InvoiceId: letterObj.invoiceId,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : ''
              };
            }
            else if (this.transactionType === 2){
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                ReceiptId: letterObj.RecepitNumber,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature ? letterObj.ObtainSignature : false,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                isEmail: letterObj.ObtainSignature ? letterObj.ObtainSignature : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != '' ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: ele.isDocumentSuccess ? true : false,
                isDocumentFailed: ele.isDocumentFailed ? true : false,
                LedgerId: this.lettersList.find(o => o.LetterId == ele.LetterId).LedgerId ? this.lettersList.find(o => o.LetterId == ele.LetterId).LedgerId : 0,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : '',
                leaseNo: ele.LeaseNo ? ele.LeaseNo : this.leaseNo,
                LinkedLeaseNo : ele.LinkedLeaseNo
              }
            }
            else {
              obj = {
                slNo: this.getLargestNum(),
                TemplateId: letterObj.TemplateId,
                ReceiptId: letterObj.RecepitNumber,
                LetterId: parseInt(ele.LetterId, 10),
                obtainSignature: letterObj.ObtainSignature ? letterObj.ObtainSignature : false,
                Processed: ele.isProcessed,
                blobUrl: ele.blobUrl,
                isDefault: true,
                LetterType: ele.LetterType,
                isEmail: letterObj.ObtainSignature ? letterObj.ObtainSignature : false,
                isEmailTemplateDefined: letterObj.ObtainSignature && letterObj.EmailTemplateDefined != null && letterObj.EmailTemplateDefined != '' ? true : false,
                isSMSTemplateDefined: letterObj.ObtainSignature && letterObj.SMSTemplatedDefined != null && letterObj.SMSTemplatedDefined != ''  ? true : false,
                isApprove: true,
                isEmailSuccess: false,
                isSmsSuccess: false,
                isDocumentSuccess: ele.isDocumentSuccess ? true : false,
                isDocumentFailed: ele.isDocumentFailed ? true : false,
                LedgerId: this.lettersList.find(o => o.LetterId == ele.LetterId).LedgerId ? this.lettersList.find(o => o.LetterId == ele.LetterId).LedgerId : 0,
                SmsContent: letterObj.ObtainSignature ? letterObj.SMSTemplatedDefined : '',
                LinkedLeaseNo : ele.LinkedLeaseNo
              }
            }
            const renderedIdentity = this.getDefaultDocumentIdentity(obj, letterObj, true);
            const existingRow = this.documentList.find(row =>
              this.getDefaultDocumentIdentity(row, letterObj, true) === renderedIdentity);
            if (!existingRow) {
              this.documentList.push(obj);
            }
            this.boundDefaultDocuments.set(identity, (existingRow || obj).slNo);
          }
        }
      });
    }
    if (this.moveInSettings && this.moveInSettings.PrintWelcomeLetter && this.transactionType == 1) {
      let lettrObj = this.lettersList.find(o => o.TemplateId == 1);
      if (lettrObj && lettrObj.TemplateId === 1) {
        this.welcomeLetterId = lettrObj.LetterId;
      }
      if (lettrObj && lettrObj.TemplateId === 1 && !this.documentList.some(row => row.LetterId == lettrObj.LetterId)) { // Welcome Letter
        let obj = {
          slNo: this.getLargestNum(),
          TemplateId: lettrObj.TemplateId,
          LetterId: lettrObj.LetterId,
          obtainSignature: lettrObj.ObtainSignature,
          Processed: false,
          blobUrl: '',
          isDefault: true,
          LetterType: 0,
          isEmail: lettrObj.ObtainSignature,
          isEmailTemplateDefined: lettrObj.ObtainSignature && lettrObj.EmailTemplateDefined != null &&  lettrObj.EmailTemplateDefined != '' ? true : false,
          isSMSTemplateDefined: lettrObj.ObtainSignature && lettrObj.SMSTemplatedDefined != null && lettrObj.SMSTemplatedDefined != '' ? true : false,
          isApprove: true,
          isEmailSuccess: false,
          isSmsSuccess: false,
          isDocumentSuccess: false,
          isDocumentFailed: false,
          leaseNo: this.leaseNo

        }
        this.documentList.push(obj);
        this.boundDefaultDocuments.set(this.getDefaultDocumentIdentity(obj, lettrObj), obj.slNo);

      }
    }
    this.documentList.slice(firstNewRow).forEach(row => {
      row.select = !!(row.isDocumentSuccess || row.isDocumentFailed);
      row.disableSelect = row.select;
    });
    if (this.documentsInitialized && firstNewRow < this.documentList.length) {
      this.selectAllCB = this.documentList.every(row => row.select);
      this.disableSelectAll = this.bulkProcess || this.documentList.every(row => row.disableSelect ||
        row.isDocumentSuccess || row.isDocumentFailed || (this.isCallCenterGroup && row.obtainSignature));
    }
    this.dropdownLettersList = this.lettersList.filter(letter =>
      letter.TemplateId === 31 || this.documentList.some(row => row.LetterId === letter.LetterId));
  }

  private getDefaultDocumentIdentity(document: any, letter: any, isRendered = false): string {
    if (isRendered) {
      letter = { RecepitNumber: document.ReceiptId, invoiceId: document.InvoiceId, LedgerId: document.LedgerId || 0 };
      document = {
        ...document,
        leaseId: document.leaseNo,
        LeaseNo: document.leaseNo,
        TenantId: document.tenantId,
        FacilityId: document.facilityId,
        RecepitNumber: document.ReceiptId
      };
    }
    const target = this.isFromRentRaise ? [document.RentRaiseId]
      : this.isfromModifyRental ? [document.LinkedLeaseNo]
      : this.IsfromBatchRentRaise ? [document.leaseId, document.RentRaiseId]
      : this.isfrombatchletters ? [document.leaseId, document.TenantId]
      : this.isfrommodifyTenantInfo ? [document.leaseNo, document.FacilityId]
      : this.transactionType === 43 ? [document.leaseId, document.FacilityId, document.RecepitNumber]
      : this.IsFromManualInvoice ? [letter.RecepitNumber, letter.invoiceId]
      : this.transactionType === 2 ? [document.LeaseNo, document.LinkedLeaseNo, letter.RecepitNumber, letter.LedgerId]
      : [document.LinkedLeaseNo, letter.RecepitNumber, letter.LedgerId];
    return JSON.stringify([document.LetterId, ...target].map(value => value == null ? null : String(value)));
  }

  getLetterName(id) {
    return this.lettersList.find(o => o.LetterId == id)?.LetterName;
  }

  disableBasedOnSetting(docItem) {
    if (this.transactionType === 1 || this.transactionType === 3 || this.transactionType === ETransactionTypes.Edit_Tenant_Info) {
      if (docItem.TemplateId === 31 && (this.miscellaneousSettings && this.miscellaneousSettings.DisplayLeaseinLettersNoticesPrintLettersMoveInandTransferScreen)
        && (!docItem.isDocumentSuccess && !docItem.isDocumentFailed)) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  changeDocument(dropVal, slNo, templateId, onApproveFlag, onEmailFlag,onSmsFlag) {
    let lettrObj = this.lettersList.find(o => o.LetterId == parseInt(dropVal));
    var index = this.documentList.findIndex(o => o.slNo == slNo);
    let obj;
    if (index !== -1) {
      let oldDoc = this.documentList[index];
      obj = {
        slNo: slNo,
        TemplateId: templateId,
        LetterId: dropVal,
        obtainSignature: lettrObj.ObtainSignature,
        Processed: oldDoc?.Processed || false,
        blobUrl: oldDoc?.blobUrl || '',
        isDefault: true,
        LetterType: lettrObj.LetterType,
        isEmail: lettrObj.ObtainSignature,
        isEmailTemplateDefined: lettrObj.ObtainSignature && lettrObj.EmailTemplateDefined != null &&  lettrObj.EmailTemplateDefined != '' ? true : false,
        isSMSTemplateDefined: lettrObj.ObtainSignature && lettrObj.SMSTemplatedDefined != null && lettrObj.SMSTemplatedDefined != '' ? true : false,
        isApprove: true,
        isEmailSuccess: false,
        isSmsSuccess: false,
        isDocumentSuccess: oldDoc?.isDocumentSuccess || false,
        isDocumentFailed: oldDoc?.isDocumentFailed || false,
        leaseNo: (this.isfrommodifyTenantInfo || this.isfrombatchletters || this.IsfromBatchRentRaise || this.transactionType == 2)? oldDoc?.leaseNo : this.leaseNo,
        tenantId: this.isfrombatchletters ? oldDoc?.tenantId : this.tenantId,
        disableSelect: false,
        itemProcessed: oldDoc?.itemProcessed || false,
        select: oldDoc?.select || false,
        ReceiptId: oldDoc?.ReceiptId || null,
        facilityId: (this.isfrommodifyTenantInfo || this.isfrombatchletters) ? oldDoc?.facilityId : this.facilityId,
        AutoCC: oldDoc?.AutoCC,
        AutoACH: oldDoc?.AutoACH,
        transactionType: oldDoc?.transactionType,
        LedgerId: lettrObj.LedgerId ? lettrObj.LedgerId : 0,
        RentRaiseId: lettrObj?.RentRaiseId ?? oldDoc?.RentRaiseId,
        SmsContent: lettrObj.ObtainSignature ? lettrObj.SMSTemplatedDefined : '',
        unsignedDocGenerated: oldDoc?.unsignedDocGenerated || false,
        LinkedLeaseNo :oldDoc.LinkedLeaseNo
      }
      this.documentList[index] = obj;
      if (oldDoc?.blobUrl) {
        let leaseObj = {
          LetterId: dropVal,
          BlobURL: oldDoc.blobUrl,
          SlNo: slNo
        };
        let idx = this.leaseBloBURLs.findIndex(b => b.LetterId === dropVal && b.SlNo === slNo);
        if (idx !== -1) {
          this.leaseBloBURLs[idx] = leaseObj;
        }
        else {
          this.leaseBloBURLs.push(leaseObj);
        }
      }

      let signatureFlag = lettrObj.ObtainSignature;
      const LetterAndNoticeId =parseInt(obj.LetterId, 10);
      let leaseBlob = this.leaseBloBURLs.length ? this.leaseBloBURLs.find(b => b.LetterId == obj.LetterId && b.SlNo == slNo) : null;
      if (signatureFlag && leaseBlob == null) {
        let tempSlNo = slNo
        let tempObj = this.generateDocumentObject(tempSlNo);
        tempObj.IsLeaseAgreement = false;
        tempObj.OnlineRentalModel = {
          CustomerSignature: null,
          CustomerInitial: null,
          UnsignedDocument: true
        }
        let letterId = parseInt(obj.LetterId, 10);
        let receiptNumber = (tempObj.ReceiptId == undefined || tempObj.ReceiptId == null) ? 0 : tempObj.ReceiptId;
        let invoiceId = 0;
        if (this.IsFromManualInvoice) {
          invoiceId = (lettrObj.invoiceId == undefined || lettrObj.invoiceId == null) ? 0 : lettrObj.invoiceId;
        }
        if (onApproveFlag || onEmailFlag || onSmsFlag) {
          this.saveUnsignedDocument(letterId, tempObj, obj.TemplateId, tempSlNo, receiptNumber, invoiceId, obj.LedgerId,
            lettrObj.LetterType, lettrObj.ObtainSignature,lettrObj.SMSTemplatedDefined);
        }
      } else if (signatureFlag && leaseBlob) {
        if (this.onApproveFlag && !this.isSMSCheckedDoc && !this.emailCheckBoxDoc) {
          this.processDocument(slNo);
        } else {
          if (this.onEmailFlag) {
            if (this.tenantLettersAndNoticesIdsForEsignature && this.tenantLettersAndNoticesIdsForEsignature.length > 0) {
              this.getEmailBody(slNo, obj.LeaseNo);
              this.currentDocument['LeaseNo'] = obj.leaseNo;
              this.slNumber = slNo;
              this.documentList.forEach(element => {
                if (element.slNo == slNo) {
                  element['unsignedDocGenerated'] = true
                }
              });
              this.modalRef = this.modalService.show(this.esignatureModal, { class: 'modal-lg modal-dialog-centered' });
            } else {
              this.modalRef.hide();
              this.toaster.warning('Email template not found. Please check.', 'Warning', this.toasterConfig);
            }
          }if (this.onSmsFlag) {
             if (this.tenantLettersAndNoticesIdsForEsignature && this.tenantLettersAndNoticesIdsForEsignature.length > 0) {
              this.messageBody = obj.SmsContent;
              this.sendMessageWithBody(this.messageBody);
              this.slNumber = slNo;
              this.documentList.forEach(element => {
                if (element.slNo == slNo) {
                  element['unsignedDocGenerated'] = true
                }
              });
             }else {
              this.modalRef.hide();
              this.toaster.warning('SMS template not found. Please check.', 'Warning', this.toasterConfig);
            }
          }
      }
    }
    }
    if (obj.LetterId == "0") {
      obj.select = false;
    } else if (this.selectAllCB) {
      obj.select = true;
    }
  }

  getLargestNum() {
    if (this.documentList.length) {
      let numArr = this.documentList.map((ele) => ele.slNo);
      return Math.max(...numArr) + 1;
    } else {
      return 1;
    }
  }

  disableDocumentOpt(letterId) {
    if (this.lettersList.length && !this.isfrommodifyTenantInfo) {
      let index = this.documentList.findIndex(o => o.LetterId == letterId);
      if (index !== -1 || letterId == "0")
        return true;
    } else if (this.isfrommodifyTenantInfo && letterId == "0") {
      return true;
    }
    return false;

  }

  sendForESignature(letterId, templateId, base64, blobURL, letterType, slNo, leaseNumber, receiptId, esignId, tenantId, LedgerId) {
    let lettersAndNoticesId = 0;
    let invoiceNumber = 0;
    let reservationNo = 0;
    let paymentReceiptId = 0;

    if (templateId == 28) {  
      invoiceNumber = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    } else if (templateId == 26) {  
      reservationNo = this.ReservationNumber ?? 0;
      lettersAndNoticesId = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    } else if (templateId == 40) {
      paymentReceiptId = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    } else {
      lettersAndNoticesId = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    }
    let documentTypeIdentifier = "";

    if (templateId == 40 && paymentReceiptId) {
      documentTypeIdentifier = "PaymentReceipts";
    } else if (invoiceNumber != 0) {
      documentTypeIdentifier = "Invoices";
    } else if (lettersAndNoticesId || reservationNo) {
      documentTypeIdentifier = "TenantLettersAndNotices";
    }
    var data = {
      FacilityId: this.facilityId,
      TenantId: this.isfrombatchletters ? tenantId : this.tenantId,
      LetterId: letterId,
      TemplateId: templateId,
      LeaseNumber: this.isfrommodifyTenantInfo || this.isfrombatchletters ? leaseNumber : this.leaseNo,
      Base64Content: base64,
      UserId: this.currentUserId,
      LetterType: letterType,
      TransactionTypeId: this.transactionType,
      TenantLettersAndNoticesId: lettersAndNoticesId,
      SlNo: slNo,
      ReceiptId: receiptId ? receiptId : 0,
      LedgerId: LedgerId ? LedgerId : 0,
      InvoiceId: invoiceNumber,
      ReservationNumber: reservationNo,
      SigningUrl: this.eSignatureType == 563 ? this.leaseDocumentResponse.find(l => l.SlNo == slNo).SigningUrl : blobURL,
      ESignatureType: this.eSignatureType,
      EnvelopeId: this.eSignatureType == 563 ? this.leaseDocumentResponse.find(l => l.SlNo == slNo).EnvelopeId : 0,
      EnvelopeCode: this.eSignatureType == 563 ? this.leaseDocumentResponse.find(l => l.SlNo == slNo).EnvelopeCode : '',
      ESignatureId: esignId,
      IsNewDocumentListProcess: false,
      DocumentTypeIdentifier: documentTypeIdentifier
    };

    this.documentService.sendMessageForESignature(data).subscribe((res: any) => {
      this.loaderIcon = Promise.resolve(false);
      this.documentList.forEach(element => {
        if (element.slNo == slNo) {
          element.isEmail = true
          element.isDocumentSuccess = true;
          element['unsignedDocGenerated'] = true
        }
        //this.onApproveFlag = false;
      });
      let docObject = this.documentList.find(o => o.slNo == slNo);
      if (docObject && this.documentResponse.TenantLettersAndNoticesAlternates && this.documentResponse.TenantLettersAndNoticesAlternates.length) {
        docObject['AlternateLetterIds'] = this.documentResponse.TenantLettersAndNoticesAlternates.map((ele) => ele.TenantLettersAndNoticesAlternatesId);
      }
      if (docObject) {
        docObject['TenantLettersAndNoticesIds'] = lettersAndNoticesId;
      }

      if (this.bulkProcess) {
        this.checkBulkProcessCompletion();
      }
    }, (error) => {
      this.loaderIcon = Promise.resolve(false);
      let docObj = this.documentList.find(o => o.slNo == slNo);
      if (docObj) {
        docObj.isDocumentFailed = true;
      }
      this.isDocGenerationfailed = true;
      this.toaster.error('Failed to send document for eSignature.', 'Error', this.toasterConfig);
      if (this.bulkProcess) {
        this.checkBulkProcessCompletion();
      }
    });
  }

  checkBulkProcessCompletion(): void {
    if (this.documentList.every((o) => o.isDocumentFailed || o.isDocumentSuccess) ||
      (this.isCallCenterGroup && this.documentList.every((item) => (!item.obtainSignature &&
        (item.isDocumentFailed || item.isDocumentSuccess)) || item.obtainSignature))) {
      if (!this.isDocGenerationfailed) {
        this.toaster.success('All documents are processed successfully!', 'Success', this.toasterConfig);
      }
      this.loaderIcon = Promise.resolve(false);
      this.bulkProcess = false;
      this.isDocGenerationfailed = false;
    }
  }

  isNextDisabled() {
    let arr = [];
    arr = this.documentList.filter(ele => ele.Processed === false);
    if (arr.length) {
      return true;
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['leaseNo']) {
      this.documentList.map((item) => {
        item['Processed'] = false;
        item['blobUrl'] = ''
        item['isDefault'] = false;
      });
    }

    if ((changes['NoentriesforLeaseAgreement'])) {
      if ((changes['NoentriesforLeaseAgreement'].currentValue) === true) {
        this.isNextDisabled();
      }
    }
    if (this.documentsInitialized && (changes['defaultDocList'] || changes['lettersList'])) {
      this.bindDefaultDocList();
    }
  }

  processDocument(slNo) {
    this.loaderIcon = Promise.resolve(true);
    let docObj = this.documentList.find(o => o.slNo == slNo);
    var leaseBlob = this.leaseBloBURLs.find(b => b.LetterId == docObj.LetterId && b.SlNo == slNo);
    if (leaseBlob?.BlobURL && docObj?.obtainSignature) {
      docObj.blobUrl = leaseBlob.BlobURL;
      if (docObj.unsignedDocGenerated && !docObj.isDocumentSuccess && !docObj.isDocumentFailed && !this.onEmailFlag && !this.onSmsFlag) {
        const esignId = this.eSignatureIds.find(e => e.LetterId == docObj.LetterId);
        this.sendForESignature(docObj.LetterId, docObj.TemplateId, null, leaseBlob.BlobURL,
          docObj.LetterType, slNo, docObj.leaseNo, docObj.ReceiptId,
          esignId?.ESignatureId, docObj.tenantId, docObj.LedgerId);
        this.slNumber = slNo;
      } else {
        this.emitgoToHostforEditInfoDoc.emit(this.leaseNo);
        this.loaderIcon = Promise.resolve(false);
      }
      return;
    }
    if (docObj.LetterId === -1) {
      this.printTenantLedger(slNo);
    } else if (docObj.LetterId === -2) {
      this.printTenantNotes(slNo);
    } else {
      let obj = this.generateDocumentObject(slNo);
      if (obj.Type == 28) {
        this.manualInvoiceGenerated = true;
      }
      if (docObj.obtainSignature && !this.onEmailFlag && !this.onSmsFlag) {
        leaseBlob = this.leaseBloBURLs.find(b => b.LetterId == docObj.LetterId && b.SlNo == slNo);
        let esignId = this.eSignatureIds.find(e => e.LetterId == docObj.LetterId)
        this.sendForESignature(docObj.LetterId, docObj.TemplateId, null, leaseBlob.BlobURL, docObj.LetterType, slNo, docObj.leaseNo, docObj.ReceiptId, esignId.ESignatureId, docObj.tenantId, docObj.LedgerId);
        //holding value for E-Signature to change Green Tick Mark after getting success message from E-Signature
        this.slNumber = slNo;
      } else {
        this.documentGenService.GenerateTenantDocument(obj).subscribe((response: any) => {
          console.log('response',response);
          let docObject = this.documentList.find(o => o.slNo == slNo);
          if (response.Success) {
            this.documentList.find(o => o.slNo == slNo).disableSelect = true;
            if (docObject) {
              docObject.blobUrl = response.BlobURL;
              docObject.Processed = true;
              docObject.isDefault = true;
              docObject.isDocumentSuccess = true;
              docObject.select = !docObject.select ? true : docObject.select;

              this.toaster.success('Document Processed Successfully!', 'Success', this.toasterConfig);
            }
            this.documentList.map((item) => {
              if (item.TemplateId == 28 && item.LetterId !== docObject.LetterId && this.IsFromManualInvoice) {
                item.Processed = docObject.Processed;
                item.isDefault = docObject.isDefault;
                item.isDocumentSuccess = docObject.isDocumentSuccess;
                item.select = docObject.select;
                item.disableSelect = docObject.disableSelect;
              }
            });
            if (docObject && response.TenantLettersAndNoticesAlternates && response.TenantLettersAndNoticesAlternates.length) {
              docObject['AlternateLetterIds'] = response.TenantLettersAndNoticesAlternates.map((ele) => ele.TenantLettersAndNoticesAlternatesId);
            }
            if (docObject) {
              if((docObject.TemplateId == ELetterAndNoticesTemplates.Payment_Receipt || 
                (docObject.TemplateId == ELetterAndNoticesTemplates.Merchandise_Campaign)) && docObject.ReceiptId) {
                if(docObject.ReceiptId !== response.Id && response.BlobURL) {
                  docObject['TenantLettersAndNoticesIds'] = response.Id;
                }
              } else if(docObject.TemplateId == ELetterAndNoticesTemplates.Invoice_letter) {
                docObject['InvoiceId'] = response.Id;
              } else {
                if(response.BlobURL) {
                  docObject['TenantLettersAndNoticesIds'] = response.Id;
                }
              }
            }
            this.emitgoToHostforEditInfoDoc.emit(this.leaseNo);           
          } else {
            this.documentList.find(o => o.slNo == slNo).disableSelect = true;
            docObject.isDocumentFailed = true;
            this.documentList.map((item) => {
              if (item.TemplateId == 28 && item.LetterId !== docObject.LetterId && this.IsFromManualInvoice) {
                item.isDocumentFailed = docObject.isDocumentFailed;
                item.disableSelect = docObject.disableSelect;
              }
            });
            docObject.select = !docObject.select ? true : docObject.select
            this.toaster.error('Failed to process document!', 'Failure', this.toasterConfig);
            this.isDocGenerationfailed = true
          }
          if (this.bulkProcess) {
            this.checkBulkProcessCompletion();
          } else {
            this.loaderIcon = Promise.resolve(false);
          }    
        }, err => {
          if (err && err.error && (err.error.error == 'Duplicate Request' || err.error.title == 'Duplicate Request') && err.status == HttpStatusCode.Conflict) {
            const model = {
              TransactionTypeId : obj.TransactionTypeId,
              LeaseNumber : obj.LeaseNumber,
              FacilityId : obj.LeaseFacilityId,
              LettersAndNoticesId : obj.LetterId,
              ReceiptId : obj.ReceiptId,
              InvoiceId : obj.InvoiceId
            }
            this.addSubscriptionDuplicateRequest(model, slNo);
          }else{       
          this.toaster.error('Failed to process document!', 'Failure', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
          this.bulkProcess = false;
        }
        });
      }
    }
  }

  disableNextButton() {
    this.documentList.map((item) => {
      if (item.isDocumentSuccess || item.isDocumentFailed) {
        item['itemProcessed'] = true;
      } else {
        item['itemProcessed'] = false;
      }
    });
    if (this.documentList.every((item) => item.itemProcessed)) {
      return false;
    } else {
      return true;
    }
  }

  generateDocumentObject(slNo) {
    let docObject = this.documentList.find(o => o.slNo == slNo);
    let obj;
    if (docObject) {
      if (this.isFromRentRaise) {
        obj = {
          LeaseNumber: this.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: ETransactionTypes.Rent_Raise,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          RentRaiseId: docObject.RentRaiseId,
          SendToAlternate: true,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.isfromModifyRental) {
        obj = {
          LeaseNumber: docObject.LinkedLeaseNo ??this.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: docObject.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          SendToAlternate: true,
          FileContents: null,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
        if (docObject.InsType) {
          obj.TransactionTypeId = ETransactionTypes.Change_Insurance;
        } else if (docObject.SSType) {
          obj.TransactionTypeId = ETransactionTypes.Schedule_Move_Out;
        } else if (docObject.AutoCC || docObject.AutoACH) {
          obj.TransactionTypeId = ETransactionTypes.Move_In;
        }

      } else if (this.transactionType === ETransactionTypes.Reservation) {
        obj = {
          ReservationNumber: this.ReservationNumber,
          ReceiptId: docObject.TemplateId == 40 ? this.ResreceiptNumber : null,
          ReservationFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          SendToAlternate: true,
          FileContents: null,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }

      } else if (this.transactionType === ETransactionTypes.Rent_Raise && !this.IsfromBatchRentRaise) {
        obj = {
          LeaseNumber: this.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          SendToAlternate: true,
          RentRaiseId: this.RentRaiseId,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.IsfromBatchRentRaise) {
        obj = {
          LeaseNumber: docObject.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          SendToAlternate: true,
          RentRaiseId: docObject.RentRaiseId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.isfrombatchletters) {
        obj = {
          LeaseNumber: docObject.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          SendToAlternate: true,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }

      } else if (this.isfrommodifyTenantInfo) {
        obj = {
          LeaseNumber: docObject.leaseNo,
          LeaseFacilityId: docObject.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          SendToAlternate: true,
          FileContents: null,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.transactionType === ETransactionTypes.Process_Credit_Card) {
        obj = {
          LeaseNumber: docObject.LinkedLeaseNo ??this.leaseNo,
          LeaseFacilityId: docObject.facilityId,
          ReceiptId: docObject.TemplateId == 40 ? docObject.ReceiptId : null,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          SendToAlternate: true,
          FileContents: null,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.isfromTransfer) {
        obj = {
          LeaseNumber: docObject.LinkedLeaseNo ??this.leaseNo,
          LeaseFacilityId: this.facilityId,
          ReceiptId: docObject.TemplateId == 40 ? docObject.ReceiptId : null,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: 389,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          SendToAlternate: true,
          PaymentModeDetailsId: 0,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      }
      else if (this.isfromAuctionManage) {
        obj = {
          PaymentModeDetailsId: 0,
          ReceiptId: docObject.ReceiptId ? docObject.ReceiptId : null,
          LeaseNumber: this.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          SendToAlternate: true,
          FileContents: null,
          auctionAmountDue: this.proAuctionAmtDue,
          AuctionProceedAmount: this.proAuctionProceed,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.IsFromManualInvoice) {
        obj = {
          PaymentModeDetailsId: 0,
          InvoiceId: docObject.ReceiptId,
          LeaseNumber: this.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          SendToAlternate: true,
          FileContents: null,
          TenantId: docObject.tenantId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      } else if (this.transactionType === 2) {
        let payDetailsID;
        if (this.payModeId) {
          payDetailsID = this.payModeId;
        } else {
          payDetailsID = 0;
        }
        obj = {
          PaymentModeDetailsId: payDetailsID,
          ReceiptId: docObject.ReceiptId ? docObject.ReceiptId : null,
          LeaseNumber: docObject.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          LedgerId: docObject.LedgerId ? docObject.LedgerId : 0,
          SendToAlternate: true,
          RegenerationofReceipt: this.RegenerationofReceipt,
          TenantId: docObject.tenantId,
          TemplateId: docObject.TemplateId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      }
      else {
        let payDetailsID;
        if (this.payModeId) {
          payDetailsID = this.payModeId;
        } else {
          payDetailsID = 0;
        }
        obj = {
          PaymentModeDetailsId: payDetailsID,
          ReceiptId:  docObject.ReceiptId?docObject.ReceiptId : null,
          LeaseNumber: docObject.LinkedLeaseNo ??this.leaseNo,
          LeaseFacilityId: this.facilityId,
          TransactionTypeId: this.transactionType,
          LetterId: docObject.LetterId,
          LetterName: '',
          Type: docObject.TemplateId,
          LetterType: docObject.LetterType,
          PrimaryTemplateFile: null,
          AlternateTemplateFile: null,
          FileContents: null,
          LedgerId: docObject.LedgerId ? docObject.LedgerId : 0,
          SendToAlternate: true,
          RegenerationofReceipt: this.RegenerationofReceipt,
          TenantId: docObject.tenantId,
          TemplateId: docObject.TemplateId,
          ObtainSignature: docObject.obtainSignature,
          EsignatureType: this.eSignatureType,
          UnsignedIpAddress: this.IPAddress
        }
      }
      return obj;
    }
  }

  goToHost() {
    this.documentPopup.hide();
    if (this.emailCheckBox ) {
        this.sendEmail('goToHost');
      }
    if (this.isSMSChecked) {
      this.sendSMS();
    }
    if (this.isPrintChecked) {
      let blobUrlList = [];
      if (this.isfrombatchletters) {
        this.documentList.forEach((ele) => {
          if (ele.blobUrl && ele.blobUrl != '') {
            blobUrlList.push(ele.blobUrl);
          }
          if (ele.isAlternateBlobPresent && ele.alternateBlobUrl) {
            blobUrlList.push(ele.alternateBlobUrl);
          }
        });
      } else {
        this.documentList.forEach((ele) => {
          if (ele.blobUrl && ele.blobUrl != '')
            blobUrlList.push(ele.blobUrl);
        });
      }
      if (blobUrlList.length) {
        this.generateAsPdf(blobUrlList);
      } else {
        this.emitgoToHost.emit(true);
      }
    } else {
      this.emitgoToHost.emit(true);
      let obj = {
        print: this.isPrintChecked,
        email: this.enableEmail
      };
      this.emitMailPrint.emit(obj);
    }
    this.connection.stop().then(function () {
      console.log('Disconnected!');
    }).catch(function (err) {
      return console.error(err.toString());
    });
  }

  generateAsPdf(Fpath) {
    var objPDF = {
      FilePath: Fpath,
    };
    var typeVal = [];
    Fpath.forEach(path => {
      typeVal.push(path);
    });
    this.paymentService.generatePDFwithSas(objPDF).subscribe(response => {
      const byteCharacters = atob(response.FileContent);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileUrl = URL.createObjectURL(blob);

      this.mdq = this.media.matchMedia("(max-width: 1090px)");

      if (this.mdq.matches || this.paymentService.isIOS()) {
        this.isDocumentDownload = true;
        let existingObject = document.getElementsByTagName("object"),
          index;
        if (existingObject !== null) {
          for (index = existingObject.length - 1; index >= 0; index--) {
            existingObject[index].parentNode.removeChild(existingObject[index]);
          }
        }
        const objTag = document.createElement("object");
        let content = "Your web browser doesn't have a PDF plugin Instead you can download the PDF file";
        objTag.innerHTML = content;
        const aTag = document.createElement('a');
        aTag.setAttribute('id', 'recdocdownload');
        aTag.href = fileUrl;
        aTag.download = 'document.pdf';
        document.body.append(aTag);
        objTag.append(aTag);
        let container = document.getElementById("recieptContainerDocument");
        container.append(objTag);
        this.printPreviewPopup.show();
        this.loaderIcon = Promise.resolve(false);
      } else {
        this.printPreviewPopup.show();
        const iFrame = document.createElement("iframe");
        iFrame.src = fileUrl;
        iFrame.style.height = '500px';
        iFrame.style.width = '100%';
        let container = document.getElementById('recieptContainerDocument');
        container.append(iFrame);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.toaster.error('Failed to fetch the document!', 'Failed', this.toasterConfig);
    });
  }

  downloadDocument(): void {
    document.getElementById('recdocdownload').click();
  }

  onEmailCheck(eve) {
    if (eve.target.checked) {
      if (!this.emailBox) {
        this.enableEmail = true;
        this.btndisable = true;
      }
      else {
        this.enableEmail = true;
        this.btndisable = false;
      }
    } else {
      this.emailBox = this.isWalkInCustomer ? '' : this.emailBox;
    }
    this.btndisable = false;
    this.enableEmail = this.isWalkInCustomer && eve.target.checked ? true : false;

  }
  onsmscheck(eve) {
    if (eve.target.checked) {
      this.enablesms = true;
    } else {
      this.enablesms = false;
      this.btndisable = false;
    }
  }

  onPrintCheck(eve) {
    if (eve.target.checked) {
      this.isPrintChecked = true;
    } else {
      this.isPrintChecked = false;
    }
  }

  onkeysms(eve) {
    if (eve.target.value != '') {
      this.btndisable = false;
    } else {
      this.btndisable = true;
    }
  }

  getResposeFromESignature() {
    this.apiBaseUrl = this.apiBaseUrl.replace('/api', '/');
    this.connection = new signalR.HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(this.apiBaseUrl + "notify")
      .build();

    this.connection.start().then(function () {
    }).catch(function (err) {
      return console.error(err.toString());
    });

    this.connection.on("ResponseMessageFromESignature", (msg) => {
      this.loaderIcon = Promise.resolve(true);
      if (msg.facilityId == this.facilityId && msg.userId == this.currentUserId) {
        this.loaderIcon = Promise.resolve(false);
        this.documentList.map(d => {
          if (d.slNo == msg.slNo) {
            d.Processed = msg.success;
            d.blobUrl = msg.blobURL;
            d.isEmail = true;
            d.disableSelect = true;
            d.isDocumentSuccess = true;
            d.select = !d.select ? true : d.select
          }
        });
        if (msg.success) {
          this.toaster.success('E-Signature Processed Successfully', 'Success', this.toasterConfig);
        } else {
          this.toaster.error('Failed to Process E-Signature!', 'Failure', this.toasterConfig);
          this.documentList.map(d => {
            if (d.slNo == msg.slNo) {
              d.isEmail = true;
              d.disableSelect = true;
              d.select = !d.select ? true : d.select
            }
          });
        }
      } else {
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  redirectToMaster() {
    this.connection.stop().then(function () {
      console.log('Disconnected!');
    }).catch(function (err) {
      return console.error(err.toString());
    });
    this.emitgoToHost.emit(true);
    this.printPreviewPopup.hide();
    this.isDocumentDownload = false;
  }

  sendEmail(from?) {
    let emailList = [];
    let obj;
    let groupedByNumber = [];
    let letterAndNoticeIds = [];
    let GeneratedId = [];
    let receiptNum = null;
    let alternateLetterIds = [];
    letterAndNoticeIds = this.documentList.filter((ele) => ele.TenantLettersAndNoticesIds !== undefined).map((ele) => ele.TenantLettersAndNoticesIds);
    GeneratedId = this.defaultDocList.filter((ele) => ele.generatedId != -1).map((ele) => ele.generatedId);
    let reciptobj = this.documentList.find(o => o.TemplateId == 40);
    reciptobj = !reciptobj && this.isWalkInCustomer ? this.documentList.find(o => o.TemplateId == 41) : reciptobj;
    let invoiceobj = this.documentList.find(o => o.TemplateId == ELetterAndNoticesTemplates.Invoice_letter);
    let cusReceiptNum = !this.isWalkInCustomer ? this.documentList.find(o => o.TemplateId == 41) : reciptobj;
    alternateLetterIds = this.documentList.filter((ele) => ele.AlternateLetterIds !== undefined).map((ele) => ele.AlternateLetterIds);
    var alternateLetterIdsArray = [].concat.apply([], alternateLetterIds);
    if (reciptobj && reciptobj.ReceiptId) {
      receiptNum = reciptobj.ReceiptId;
    } else if (cusReceiptNum != null && !this.isWalkInCustomer) {
      receiptNum = cusReceiptNum.ReceiptId;
    }
    if (this.isfrombatchletters) {
      this.defaultDocList.forEach((ele) => {
         obj = {
          InquiryNo: null,
          ReservationNo: null,
          LeaseNo: ele.leaseId,
          FacilityId: this.facilityId,
          ToEmailAddress: "",
          InvoiceNumber: null,
          ReceiptNumber: null,
          TransactionTypeId: this.transactionType,
          TenantLettersAndNoticesIds: [ele.generatedId],
          TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
          SendToPrimary: !!ele.generatedId,
          SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,          
          IpAddress: ''
        };
        emailList.push(obj);
      });
    } else if (this.IsfromBatchRentRaise) {
      this.documentList.forEach((ele) => {
         obj = {
          InquiryNo: null,
          ReservationNo: null,
          LeaseNo: ele.leaseNo,
          FacilityId: this.facilityId,
          ToEmailAddress: this.emailBox,
          InvoiceNumber: null,
          ReceiptNumber: null,
          TransactionTypeId: this.transactionType,
          TenantLettersAndNoticesIds: [ele.TenantLettersAndNoticesIds],
          TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
          SendToPrimary: !!ele.TenantLettersAndNoticesIds,
          SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,          
          IpAddress: '',
          SelectedTemplateId: this.selectedEmailTemplate
        };
        emailList.push(obj);
      });
    } else if (this.isfromModifyRental) {
      let changeINSLetterIds = this.documentList.filter((ele) => ele.TenantLettersAndNoticesIds && ele.transactionType == 10).map((ele) => ele.TenantLettersAndNoticesIds);
      let schMoveoutLetterIds = this.documentList.filter((ele) => ele.TenantLettersAndNoticesIds && ele.transactionType == 12).map((ele) => ele.TenantLettersAndNoticesIds);
      let autopayLetterIds = this.documentList.filter((ele) => ele.TenantLettersAndNoticesIds && (ele.TemplateId == ELetterAndNoticesTemplates.Automatic_Credit_Card_Form || ele.TemplateId == ELetterAndNoticesTemplates.Automatic_ACH_Form)).map((ele) => ele.TenantLettersAndNoticesIds);
      if (changeINSLetterIds.length) {
         obj = {
          InquiryNo: null,
          ReservationNo: this.ReservationNumber,
          LeaseNo: this.leaseNo,
          FacilityId: this.facilityId,
          ToEmailAddress: this.emailBox,
          InvoiceNumber: null,
          ReceiptNumber: receiptNum,
          TransactionTypeId: 10,
          TenantLettersAndNoticesIds: changeINSLetterIds,
          TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
          SendToPrimary: changeINSLetterIds && changeINSLetterIds.length > 0,
          SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,          
          IpAddress: '',
          SelectedTemplateId: this.selectedEmailTemplate
        }
        emailList.push(obj);
      }
      if (schMoveoutLetterIds.length) {
         obj = {
          InquiryNo: null,
          ReservationNo: this.ReservationNumber,
          LeaseNo: this.leaseNo,
          FacilityId: this.facilityId,
          ToEmailAddress: this.emailBox,
          InvoiceNumber: null,
          ReceiptNumber: receiptNum,
          TransactionTypeId: 12,
          TenantLettersAndNoticesIds: schMoveoutLetterIds,
          TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
          SendToPrimary: schMoveoutLetterIds && schMoveoutLetterIds.length > 0,
          SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,          
          IpAddress: '',
          SelectedTemplateId: this.selectedEmailTemplate
        }
        emailList.push(obj);
      }
      if (autopayLetterIds.length) {
         obj = {
          InquiryNo: null,
          ReservationNo: this.ReservationNumber,
          LeaseNo: this.leaseNo,
          FacilityId: this.facilityId,
          ToEmailAddress: this.emailBox,
          InvoiceNumber: null,
          ReceiptNumber: receiptNum,
          TransactionTypeId: 42,
          TenantLettersAndNoticesIds: autopayLetterIds,
          TenantAlternateLettersAndNoticesIds: alternateLetterIds,
          SendToPrimary: autopayLetterIds && autopayLetterIds.length > 0,
          SendToAlternate: alternateLetterIds && alternateLetterIds.length > 0,          
          IpAddress: '',
          SelectedTemplateId: this.selectedEmailTemplate
        }
        emailList.push(obj);
      }
    } else if (this.transactionType == 43) {

      var uniqueDocument = this.documentList.filter((item, i, arr) => arr.findIndex((t) => t.leaseNo === item.leaseNo) === i);
      uniqueDocument.forEach((ele) => {
         obj = {
          InquiryNo: null,
          ReservationNo: this.ReservationNumber,
          LeaseNo: ele.leaseNo,
          FacilityId: this.facilityId,
          ToEmailAddress: ele.TenantEmail,
          InvoiceNumber: null,
          ReceiptNumber: ele.ReceiptId,
          TransactionTypeId: this.transactionType,
          TenantLettersAndNoticesIds: letterAndNoticeIds,
          TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
          SendToPrimary: letterAndNoticeIds && letterAndNoticeIds.length > 0,
          SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,          
          IpAddress: '',
          SelectedTemplateId: ele.LetterId
        }
        emailList.push(obj);
      });
    }
    else if (this.transactionType == 14) {
      obj = {
        InquiryNo: null,
        ReservationNo: null,
        LeaseNo: this.leaseNo,
        FacilityId: this.facilityId,
        ToEmailAddress: this.emailBox,
        InvoiceNumber: null,
        ReceiptNumber: null,
        TransactionTypeId: this.transactionType,
        TenantLettersAndNoticesIds: letterAndNoticeIds,
        TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
        SendToPrimary: letterAndNoticeIds && letterAndNoticeIds.length > 0,
        SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,        
        IpAddress: '',
        SelectedTemplateId: this.documentList.find(ele => ele.LetterId !== undefined)?.LetterId
      }
      emailList.push(obj);
    }
    else {
       obj = {
        InquiryNo: null,
        ReservationNo: this.ReservationNumber,
        LeaseNo: this.leaseNo,
        FacilityId: this.facilityId,
        ToEmailAddress: this.emailBox,
        InvoiceNumber: invoiceobj && invoiceobj.ReceiptId ? invoiceobj.ReceiptId : null,
        ReceiptNumber: this.transactionType == ETransactionTypes.Payment_Reversal ? this.receiptId : receiptNum,
        TransactionTypeId: this.transactionType,
        TenantLettersAndNoticesIds: letterAndNoticeIds,
        TenantAlternateLettersAndNoticesIds: alternateLetterIdsArray,
        SendToPrimary: (letterAndNoticeIds && letterAndNoticeIds.length > 0) || receiptNum > 0 || invoiceobj?.ReceiptId > 0,
        SendToAlternate: alternateLetterIdsArray && alternateLetterIdsArray.length > 0,          
        IpAddress: '',
        SelectedTemplateId: this.selectedEmailTemplate
      }
      emailList.push(obj);
    }
    let docObject = this.documentList.find(o => o.slNo === this.slNumber);
    if (docObject) {
      docObject.isApprove = false;
    }
    this.emailAndSmsService.composeEmail(emailList).subscribe((response: any[]) => {
      if (response[0].Success) {
        this.documentList.map(o => {
          if (o.slNo === this.slNumber) {
            if (!from) {
              o.isEmailSuccess = true;
            }
            o.isDocumentSuccess = true;
            o.select = !o.select ? true : o.select
          }
        });
        this.toaster.success('Email Sent Successfully', 'Success', this.toasterConfig);

      }
      else {
        this.documentList.map(o => {
          if (o.slNo === this.slNumber) {
            if (!from) {
              o.isDocumentFailed = true;
            }
            o.select = !o.select ? true : o.select
          }
        });
        this.toaster.error('Failed to send email', 'Failure', this.toasterConfig);
      }

      this.modalRef.hide();
    });
  }

  sendSMS() {
    let smsList = [];
    let obj = {
      InquiryNo: null,
      ReservationNo: this.ReservationNumber,
      LeaseNo: this.leaseNo,
      FacilityId: this.facilityId,
      TransactionTypeId: this.transactionType,
      SelectedTemplateId: this.selectedSMSTemplate
    };
    smsList.push(obj);
    this.emailAndSmsService.composeSMS(smsList).subscribe((response: any[]) => {
      if (response[0].Success) {
        this.toaster.success('SMS Sent Successfully!', 'Success', this.toasterConfig);
      } else {
        this.toaster.error('Failed to send SMS!', 'Failure', this.toasterConfig);
      }
    }, err => {
      this.toaster.error('Failed to send SMS!', 'Failure', this.toasterConfig);
    });
  }

  showemail = true;
  emailprocess = false;

  completeemail() {
    this.showemail = false;
    this.emailprocess = true;
  }

  openEsignatureModal(slNo, docDetails) {
    let obj = this.documentList.find((item) => item.slNo == slNo);
    docDetails = docDetails ? docDetails : obj;
    this.onEmailFlag = true;
    this.currentDocument = docDetails;
    this.slNumber = slNo;
    this.changeDocument(obj.LetterId, slNo, docDetails.TemplateId, this.onApproveFlag, this.onEmailFlag,this.onSmsFlag)
  }

   closeEsignatureModal() {
    this.modalRef.hide();
  }
openSmsModal(slNo, docDetails) {
  const obj = this.documentList.find((item) => item.slNo == slNo);
  docDetails = docDetails ? docDetails : obj;

  this.onSmsFlag = true;
  this.currentDocument = docDetails;
  this.slNumber = slNo;

  this.changeDocument( obj.LetterId,slNo,docDetails.TemplateId, this.onApproveFlag,false,this.onSmsFlag);
}

 
   
  clickNextButton() {
    if (this.isOneLocal === true) {
      if ((this.SendDetailsToOneLocal === true) && (this.transactionType === ETransactionTypes.Move_In && !this.isExemptFromSendingDetailsToOneLocal) ||
        (this.transactionType === ETransactionTypes.Move_Out && this.SendDetailsToOneLocal === true) ||
        (this.transactionType === ETransactionTypes.Transfer && !this.isExemptFromSendingDetailsToOneLocal && this.SendDetailsToOneLocal === true)) {
        this.modalRefOneLocal = this.modalService.show(this.OneLocalPopup, {
          class: "modal-dialog modal-dialog-centered",
          backdrop: 'static'
        });
      } else {
        this.documentPopup.show();
      }
    } else {
      this.documentPopup.show();
    }
    if (this.isWalkInCustomer) {
      this.emailBox = '';
      this.emailCheckBox = false;
      this.enableEmail = false;
    }
    var data = {
      FacilityId: this.facilityId,
      TenantId: this.tenantId,
      LetterId: 0,
      TemplateId: 0,
      LeaseNumber: 0,
      Base64Content: '',
      UserId: this.currentUserId,
      LetterType: '',
      TransactionTypeId: 0,
      TenantLettersAndNoticesId: 0,
      SlNo: -1,
      ReceiptId: 0,
      InvoiceId: 0,
      ReservationNumber: 0,
      SigningUrl: '',
      ESignatureType: this.eSignatureType,
      EnvelopeId: 0,
      EnvelopeCode: '',
      ESignatureId: 0,
      IsNewDocumentListProcess: true,
      LedgerId: 0
    };

    this.documentService.sendMessageForESignature(data).subscribe((res: any) => {
    });
  }

  getFacilityInternetSettings(facId) {
    this.storeService.GetFacilityInternetSettingsForOp(facId).subscribe((response: IInternetSettings) => {
      if (response !== null) {
        this.tempfacilityInternetSettings = response;
        if (response.ReputationManagementSetting.length != 0) {
          response.ReputationManagementSetting.forEach(ele => {
            if (ele.ReputationId == 612 || ele.ReputationId == 614) {
              this.ReputationActive = true;
            }
          });
        }
        if (this.ReputationActive === true) {
          if (this.transactionType === ETransactionTypes.Move_In) {
            if (this.isExemptFromSendingDetailsToOneLocal === false) {
              this.SendDetailsToOneLocal = true;
            }
          } else if (this.transactionType === ETransactionTypes.Transfer) {
            this.GetLeaseRestrictions(this.transferedOutLeaseNo, this.facilityId);
          } else if (this.transactionType === ETransactionTypes.Move_Out) {
            this.GetLeaseRestrictions(this.leaseNo, this.facilityId);
          }
        }
      }
    });
  }
  
  GetLeaseRestrictions(leaseNo, facilityId) {
    this.customerService.GetLeaseRestrictions(leaseNo, facilityId).subscribe((response: any) => {
      if (response.ExemptFromSendingDetailsToOneLocal === false) {
        this.SendDetailsToOneLocal = true;
      }
    });
  }

  OneLocalPopOKAction() {
    this.modalRefOneLocal.hide();
    this.documentPopup.show();
    const data = {
      LeaseNumber: this.leaseNo,
      FacilityId: this.facilityId,
      TransactionTypeId: this.transactionType,
      TransferIn: !this.isExemptFromSendingDetailsToOneLocal,
      TransferOut: this.SendDetailsToOneLocal,
    };
    this.emailAndSmsService.SendEmailToReputationManagement(data).subscribe((response: any) => {
      response.forEach(ele => {
        if (ele.Success) {
          if (ele.Message) {
            this.toaster.success(ele.Message, 'Success', this.toasterConfig);
          }
        } else {
          this.toaster.error(ele.Message, 'Error', this.toasterConfig);
        }
      });
    },
      (err: any) => {
      });
  }

  saveOneLocalNotes() {
    this.modalRefNotesOneLocal.hide();
    this.saveNotesApi(this.leaseNo, this.facilityId);
    this.documentPopup.show();
  }

  openNotesOneLocalPopup(template: TemplateRef<any>) {
    this.modalRefNotesOneLocal = this.modalService.show(template, { class: "modal-dialog modal-dialog-centered", backdrop: 'static' });
    this.modalRefOneLocal.hide();
  }

  saveNotesApi(leaseNumber, facilityId) {
    let isCallCenterGroup = false;
    if (this.userSessionService) {
      isCallCenterGroup = this.userSessionService.isCallcenterAgent === true ? true : false;
    }
    const obj = {
      NotesId: 0,
      LeaseNo: leaseNumber,
      FacilityId: facilityId,
      ReservationNumber: null,
      ReservationFacilityId: null,
      InquiryNumber: null,
      InquiryFacilityId: null,
      InquiryNotesFacilityId: null,
      FollowUpId: null,
      NotesDate: new Date(),
      Text: this.notesOneLocalCancel,
      CustomerNotes: false,
      PriorityNote: false,
      CollectionCall: false,
      PaymentReceiptId: null,
      DisplayAlert: isCallCenterGroup,
      UnitNo: this.unitNum,
      TransactionTypeId: this.transactionType,
      Creator: null
    };
    this.prospectsService.SaveNotes(obj).subscribe((response: any) => {
      if (response.Success) {
        this.toaster.success('Notes Saved Successfully', 'Success', this.toasterConfig);
      } else {
      }
    },
      (err: any) => {
      });
  }

  getEmailBody(slNo, leaseNo?) {
    let lettersAndNoticesIds = [];
    let receiptNumber = 0;
    let invoiceNumber = 0;
    let reservationNo = null;

    let templateId = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).TemplateId;
    let LetterId = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).LetterId;
    if (templateId == 40) {
      receiptNumber = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    } else if (templateId == 28) {
      invoiceNumber = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    } else if (templateId == 26) {
      reservationNo = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
    } else {
      let lettersAndNoticesId = this.tenantLettersAndNoticesIdsForEsignature.find(tl => tl.SlNo == slNo).Id;
      if (lettersAndNoticesId) {
        lettersAndNoticesIds.push(lettersAndNoticesId);
      }
    }
    this.onEmailFlag = false;

    let docObject = this.documentList.find(o => o.slNo == slNo);
    let currentLeaseNumber = leaseNo;
    let currentFacilityId = this.facilityId;
    if (docObject) {
      currentLeaseNumber = docObject.leaseNo ? docObject.leaseNo : leaseNo;
      currentFacilityId = docObject.facilityId ? docObject.facilityId : this.facilityId;
    }

    this.unitInfoLoader = Promise.resolve(true);
    let obj = {
      InquiryNo: null,
      ReservationNo:this.ReservationNumber ? this.ReservationNumber : "",
      ReservationFacilityId: this.facilityId,
      LeaseNo: currentLeaseNumber,
      FacilityId: currentFacilityId && currentFacilityId != 0 ? currentFacilityId : this.facilityId,
      ToEmailAddress: this.emailBox,
      FromEmailAddress: '',
      CCEmailAddress: '',
      BCCEmailAddress: '',
      CCToStoreEmailAddress: '',
      TransactionTypeId: 46,
      InvoiceNumber: invoiceNumber,
      ReceiptNumber: receiptNumber,
      TenantLettersAndNoticesIds: lettersAndNoticesIds,
      TenantAlternateLettersAndNoticesIds: [],
      SendToAlternate: true,
      IpAddress: '',
      DripcampaignActionId: null,
      DripcampaignLetterId: null,
      SelectedTemplateId: LetterId
    };
    this.documentGenService.getEmailBody(obj).subscribe((response: ISendEmailOutputModel) => {
      if (response && response.EmailModel && response.EmailModel.EmailBody && response.EmailModel.Subject) {
        this.emailfullContent = response;
        this.currentSubject = this.emailfullContent.EmailModel.Subject;
        let emailBody = this.emailfullContent.EmailModel.EmailBody.replace('{EsignatureBaseURL}', environment.esignatureBaseURL);
        this.rteValue = emailBody;
        this.sendEmailForm.get("toAddress").setValue(this.emailfullContent.EmailModel.ToAddress);
        this.sendEmailForm.get("ccAddress").setValue(this.emailfullContent.EmailModel.CcAddress);
        if(this.emailAndSmsBox && this.emailAndSmsflag)
        {
          this.sendEmailForm.get("toAddress").setValue(this.emailAndSmsBox);
        }
        this.documentList.map(element => {
          if (element.slNo == slNo) {
            element['currentSubject'] = this.currentSubject;
            element['rteValue'] = this.rteValue;
          }
        });
      } else {
        this.modalRef.hide();
        this.toaster.warning('Email template not found. Please check.', 'Warning', this.toasterConfig);
      }
      this.unitInfoLoader = Promise.resolve(false);
    });
  }

  sendEmailWithBody() {
    let emailmodel = [];
    let emailList = [];
    let splitToEmailAddress = this.sendEmailForm.value.toAddress.split(/[,|;]/);
    let emodel = {
      Subject: this.emailfullContent.EmailModel.Subject,
      EmailBody: this.rteValue,
      FromAddress: this.emailfullContent.EmailModel.FromAddress,
      ToAddress: splitToEmailAddress.length > 1 ? splitToEmailAddress[0] : this.sendEmailForm.value.toAddress,
      CcAddress: this.sendEmailForm.value.ccAddress && this.sendEmailForm.value.ccAddress.split(/[,|;]/).length > 1 ? this.sendEmailForm.value.ccAddress.split(/[,|;]/)[0] : this.sendEmailForm.value.ccAddress,
      BccAddress: this.emailfullContent.EmailModel.BccAddress,
      ToList: this.generateToAddressList(this.sendEmailForm.value.toAddress),
      CcList: this.generateCCAddressList(this.sendEmailForm.value.ccAddress),
      BccList: [],
      Files: [],
    };
    emailmodel.push(emodel);
    let emailbody = {
      EmailIdentifier: 1,
      EmailModel: emodel,
      LeaseNo: this.currentDocument.LeaseNo,
      FacilityId: this.facilityId,
      ReservationNumber: this.ReservationNumber ? this.ReservationNumber : null,
      InquiryNumber: null,
      FollowUpId: null,
      DripCampaignActionId: null,
      Description: this.emailfullContent.EmailModel.Subject,
      Type: 0,
      TypeReferenceId: 0,
      SendtoAlternate: true,
      TransactionTypeId: 46,
      Ip: '',
      SentTo: 386,
      TenantID: this.tenantId,
      SentRegisteredEmail: this.emailfullContent.SentRegisteredEmail,
    };
    emailList.push(emailbody);
    this.loaderIcon = Promise.resolve(true);
    this.unSingedDocumentService.sendEmail(emailList).subscribe((response: ISendEmailOutput[]) => {
      if (response[0].Success) {
        this.documentList.map(o => {
          if (o.slNo === this.slNumber) {
            o.isEmailSuccess = true;
            o.isDocumentSuccess = true;
            o.select = !o.select ? true : o.select
            o.isApprove = false;
            o.disableSelect = true;
          }
        });

        this.loaderIcon = Promise.resolve(false);
        this.toaster.success('Email Sent Successfully', 'Success', this.toasterConfig);
      } else {
        this.toaster.error('Failed to send email', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
      this.modalRef.hide();
    }, err => {
      this.toaster.error('Failed to send email', 'Failure', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      this.modalRef.hide();
    });
  }

  generateToAddressList(data) {
    if (data.split(/[,|;]/).length > 1) {
      let tempToAddressList = data.split(/[,|;]/);
      let toAddressList = [];
      tempToAddressList.forEach(element => {
        let obj = {
          Name: "",
          Email: element
        }
        toAddressList.push(obj);
      });
      toAddressList = toAddressList.filter(e => e.Email !== this.emailBox)
      if (toAddressList.length > 1) {
        toAddressList = toAddressList.slice(1);
      }
      return toAddressList;
    } else {
      return [];
    }
  }

  generateCCAddressList(data) {
    if (data && data.split(/[,|;]/).length > 1) {
      let tempCCAddressList = data.split(/[,|;]/);
      let ccAddressList = [];
      tempCCAddressList.forEach(element => {
        let obj = {
          Name: "",
          Email: element
        }
        ccAddressList.push(obj);
      });
      ccAddressList = ccAddressList.filter(e => e.Email !== this.emailfullContent.EmailModel.CcAddress)
      return ccAddressList;
    } else {
      return [];
    }
  }

  getReportUrl() {
    this.generalService.getReportUrl().subscribe((response: any) => {
      this.reportUrl = response;
    });
  }

  printTenantLedger(slNo) {
    this.loaderIcon = Promise.resolve(true);
    const datepipe: DatePipe = new DatePipe('en');
    this.periodFromDateLedger = datepipe.transform(new Date(this.periodFromDateLedger), 'MM/dd/yyyy');
    const reportParameters = {
      ToDate: datepipe.transform(new Date(new Date()), 'MM/dd/yyyy'),
      FromDate: this.periodFromDateLedger,
      TenantId: this.tenantId,
      LeaseNo: this.leaseNo
    };

    const inputModel = {
      ReportName: 'CustomerLedger',
      ReportParameters: reportParameters,
      SortBy: 1,
      IsApplication: true,
      StorageFacilities: [
        this.facilityId
      ]
    };

    const openInNewTab = '_blank';
    this.reportService.generateReport(inputModel).subscribe((response: IReportResponse) => {
      if (response.Success) {
        this.documentList.find(o => o.slNo == slNo).disableSelect = true;
        window.open(this.reportUrl + `report?id=` + response.ReportRequestId,
          openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
        let docObject = this.documentList.find(o => o.slNo == slNo);

        if (docObject) {
          docObject.blobUrl = '';
          docObject.Processed = true;
          docObject.isDefault = true;
          docObject.isDocumentSuccess = true;
          docObject.select = !docObject.select ? true : docObject.select

          this.toaster.success('Document Processed!', 'Success', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      } else {
        console.log('Ledger generation Failed', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }

    });
  }

  printTenantNotes(slNo) {
    this.loaderIcon = Promise.resolve(true);
    const datepipe: DatePipe = new DatePipe('en');
    this.periodFromDateNotes = datepipe.transform(new Date(this.periodFromDateNotes), 'MM/dd/yyyy');
    const reportParameters = {
      ToDate: datepipe.transform(new Date(new Date()), 'MM/dd/yyyy'),
      FromDate: this.periodFromDateNotes,
      TenantId: this.tenantId,
      LeaseNo: this.leaseNo
    };

    const inputModel = {
      ReportName: 'TenantsNotes',
      ReportParameters: reportParameters,
      SortBy: 1,
      IsApplication: true,
      StorageFacilities: [
        this.facilityId
      ]
    };

    const openInNewTab = '_blank';
    this.reportService.generateReport(inputModel).subscribe((response: IReportResponse) => {
      if (response.Success) {
        this.documentList.find(o => o.slNo == slNo).disableSelect = true;
        window.open(this.reportUrl + `report?id=` + response.ReportRequestId,
          openInNewTab, 'width=' + (screen.availWidth - 5) + ',height=' + (screen.availHeight - 5));
        let docObject = this.documentList.find(o => o.slNo == slNo);

        if (docObject) {
          docObject.blobUrl = '';
          docObject.Processed = true;
          docObject.isDefault = true;
          docObject.isDocumentSuccess = true;
          docObject.select = !docObject.select ? true : docObject.select

          this.toaster.success('Document Processed!', 'Success', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
        }
      } else {
        console.log('Ledger generation Failed', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  selectAll(eve) {
    if (eve.target.checked) {
      this.selectAllCB = true;
      this.documentList.map(ele => {
        if (ele.LetterId == "0") {

        } else {
          ele['select'] = true
        }
      });
    } else {
      this.selectAllCB = false;
      this.documentList.map(ele => {
        ele['select'] = false
      });
    }
  }

  processAll() {
    this.onApproveFlag = true;
    this.emailCheckBoxDoc = false;
    this.isSMSCheckedDoc = false;
    this.isDocGenerationfailed = false;
    this.bulkProcess = true;
    this.esignatureService.eSignatureMessagesList = [];
    this.documentList.map(ele => {
      if (ele['select']) {
        this.disableSelectAll = true;
        if (ele.TemplateId == 28 && this.IsFromManualInvoice && this.manualInvoiceGenerated) {

        } else if (ele.obtainSignature) {
          if (!this.isCallCenterGroup) {
            this.changeDocument(ele.LetterId, ele.slNo, ele.TemplateId, this.onApproveFlag, this.onEmailFlag,this.onSmsFlag)
          }
        } else {
          this.processDocument(ele.slNo);
        }
      }
    });
  
  }

  disableProcessAll() {
    if (!this.selectAllCB) {
      return true;
    } else if (this.documentList.every(ele => (ele.isDocumentSuccess || ele.isDocumentFailed) || (this.isCallCenterGroup && ele.obtainSignature))) {
      this.disableSelectAll = true;
      return true;
    } else if (this.isfrombatchletters && this.selectAllCB && this.disableSelectAll) {
      return true;
    }
    return false;
  }

  individualSelect(checked, slNo) {
    if (checked) {
      this.documentList.find(o => o.slNo == slNo).select = true;
      let docList = [];
      this.documentList.map((item) => {
        if (item.LetterId == "0") {

        } else {
          docList.push(item);
        }
      })
      if (docList.every(ele => ele.select == true)) {
        this.selectAllCB = true;
      }
    } else {
      this.selectAllCB = false;
    }
  }

  saveUnsignedDocument(letterId, obj, templateId, slNo, receiptNumber, invoiceId, LedgerId, letterType?, obtainSignature?,smsContent?) {
    this.signatureDocumentCount++;
    this.loaderIcon = Promise.resolve(true);
    this.documentGenService.GenerateTenantDocument(obj).subscribe((response: any) => {
      this.loaderIcon = Promise.resolve(false);
      let templetterIds = { LetterId: 0 }
      templetterIds.LetterId = letterId;
      let tempTemplateId = templateId;
      let tempSlNo = slNo;

      let docObject = this.documentList.find(o => o.slNo == slNo);
      let currentLeaseNumber = obj.LeaseNumber;
      let currentFacilityId = obj.LeaseFacilityId ? obj.LeaseFacilityId : this.facilityId;
      if (docObject) {
        if (this.eSignatureType !== 563) {
          docObject.blobUrl = response.Success ? response.BlobURL : docObject.blobUrl;
        }
        currentLeaseNumber = docObject.leaseNo ? docObject.leaseNo : obj.LeaseNumber;
        currentFacilityId = docObject.facilityId ? docObject.facilityId : obj.LeaseFacilityId; 
      }
      this.documentResponse = response;
      if (response.Success) {
        if (this.eSignatureType === 563) {
          let rSignObj = {
            Id: response.Id,
            LetterId: templetterIds.LetterId,
            SlNo: tempSlNo,
            SigningUrl: response.SigningUrl,
            EnvelopeCode: response.EnvelopeCode,
            EnvelopeId: response.EnvelopeId
          };

          this.leaseDocumentResponse.push(rSignObj);
        }

        let lettersAndNoticesObj = {
          Id: response.Id,
          LetterId: templetterIds.LetterId,
          SlNo: tempSlNo,
          TemplateId: tempTemplateId
        }
        let index = this.tenantLettersAndNoticesIdsForEsignature.findIndex((ele) => ele.SlNo == tempSlNo)
        if (index == -1) {
          this.tenantLettersAndNoticesIdsForEsignature.push(lettersAndNoticesObj); // required to delete the sample lease agreement
        } else {
          this.tenantLettersAndNoticesIdsForEsignature[index] = lettersAndNoticesObj;
        }
        let leaseObj = {
          LetterId: letterId,
          BlobURL: response.BlobURL,
          SlNo: tempSlNo,
        }
        let index2 = this.leaseBloBURLs.findIndex((item) => item.LetterId == letterId && item.SlNo == tempSlNo);
        if (index2 == -1) {
          this.leaseBloBURLs.push(leaseObj);
        } else {
          this.leaseBloBURLs[index] = leaseObj;
        }
        if (obtainSignature && !this.onEmailFlag && !this.onSmsFlag) {
          this.sendForESignature(letterId, templateId, null, response.BlobURL, letterType, slNo, currentLeaseNumber, 
            response.ReceiptId, response.ESignatureId, docObject.tenantId, LedgerId);
        }

        if (response.ESignatureId && response.ESignatureId > 0) {
          let obj = {
            LetterId: letterId,
            ESignatureId: response.ESignatureId
          }
          this.eSignatureIds.push(obj)
        }

        if (this.onApproveFlag && !this.onEmailFlag) {
          this.processDocument(slNo);
        } else if (this.onEmailFlag) {
          if (this.tenantLettersAndNoticesIdsForEsignature && this.tenantLettersAndNoticesIdsForEsignature.length > 0) {
            this.getEmailBody(slNo, obtainSignature.LeaseNumber);
            this.currentDocument['LeaseNo'] = currentLeaseNumber;
            this.slNumber = slNo;
            this.documentList.forEach(element => {
              if (element.slNo == slNo) {
                element['unsignedDocGenerated'] = true
              }
            });
            this.modalRef = this.modalService.show(this.esignatureModal, { class: 'modal-lg modal-dialog-centered' });
          } else {
            this.modalRef.hide();
            this.toaster.warning('Email template not found. Please check.', 'Warning', this.toasterConfig);
          }
        }

        if (this.onSmsFlag) {
          if (this.tenantLettersAndNoticesIdsForEsignature && this.tenantLettersAndNoticesIdsForEsignature.length > 0) {
            this.messageBody = smsContent;
            this.sendMessageWithBody(this.messageBody);
            this.slNumber = slNo;
            this.documentList.forEach(element => {
              if (element.slNo == slNo) {
                element['unsignedDocGenerated'] = true
              }
            });
          }
        }
      } else {
        const document = this.documentList.find(e => e.slNo == slNo);
        if (document) document.isDocumentFailed = true;
        this.onApproveFlag = false;
      }
    }, err =>{
      if (err && err.error && (err.error.error == 'Duplicate Request' || err.error.title == 'Duplicate Request') && err.status == HttpStatusCode.Conflict) {
        const model = {
          TransactionTypeId : obj.TransactionTypeId,
          LeaseNumber : obj.LeaseNumber,
          FacilityId : obj.LeaseFacilityId,
          LettersAndNoticesId : obj.LetterId,
          ReceiptId : obj.ReceiptId,
          InvoiceId : obj.InvoiceId,
          letterType : letterType ? letterType : 0,
          LedgerId : LedgerId
        }
        this.addSubscriptionDuplicateRequest(model, slNo);
      }
    });
  }

  disableButtons(docItem) {
    if (docItem.LetterId == "0" || this.bulkProcess) {
      return true;
    } else {
      return false;
    }
  }
  async getIpAddress(){
    try {
      this.IPAddress = await ipv4();
    } catch {
      this.IPAddress = '';
    }
  }

  disableButtonsEsign(docItem) {
    if (docItem.LetterId == "0") {
      return true;
    } else {
      return false;
    }    
  }

  disableCheckAll() {
    if (this.documentList.every(ele => ele.LetterId == "0")) {
      this.selectAllCB = false;
      return true;
    } else {
      if (this.documentList.every(ele => ele.isDocumentSuccess || ele.isDocumentFailed)) {
        this.selectAllCB = true;
        return true;
      } else if (this.documentList.every(ele => ele.obtainSignature) && this.isCallCenterGroup) {
        return true;
      } else {
        return false;
      }
    }
  }

  onChangeEmailTemplate(templateId) {
    this.selectedEmailTemplate = templateId;
  }

  onChangeSMSTemplate(templateId) {
    this.selectedSMSTemplate = templateId;
  }

  onApprove(slNo, templateId) {
    this.onApproveFlag = true;
    let obj = this.documentList.find((item) => item.slNo == slNo);
    this.changeDocument(obj.LetterId, slNo, templateId, this.onApproveFlag, this.onEmailFlag,this.onSmsFlag)
  }

  getESignatureType() {
    this.documentGenService.getEmailAndSMSSetting().subscribe(res => {
      this.eSignatureType = res.EsignService
    })
  }

  onRecapture(docItem) {
    var leaseBlob = this.leaseBloBURLs.find(b => b.LetterId == docItem.LetterId && b.SlNo == docItem.slNo);
    let esignId = this.eSignatureIds.find(e => e.LetterId == docItem.LetterId)
    this.sendForESignature(docItem.LetterId, docItem.TemplateId, null, leaseBlob.BlobURL, docItem.LetterType, docItem.slNo, docItem.leaseNo, docItem.ReceiptId, esignId.ESignatureId, docItem.tenantId, docItem.LedgerId);
  }

  onResend(docItem) {
  const label = this.getButtonLabel(docItem);
  if (label === 'Email') {
    if (docItem.currentSubject && docItem.rteValue) {
      this.currentSubject = docItem.currentSubject;
      this.rteValue = docItem.rteValue;
      this.modalRef = this.modalService.show(this.esignatureModal, {
        class: 'modal-lg modal-dialog-centered',
      });
    } else {
      let leaseNo = this.isfrommodifyTenantInfo ? docItem.leaseNo : this.leaseNo;
      this.currentDocument = docItem;
      if (this.tenantLettersAndNoticesIdsForEsignature?.length > 0) {
        this.getEmailBody(docItem.slNo, leaseNo);
        this.currentDocument['LeaseNo'] = leaseNo;
        this.slNumber = docItem.slNo;
        this.documentList.map((element) => {
          if (element.slNo == docItem.slNo) {
            element['unsignedDocGenerated'] = true;
          }
        });

        this.modalRef = this.modalService.show(this.esignatureModal, {
          class: 'modal-lg modal-dialog-centered',
        });
      } else {
        this.modalRef.hide();
        this.toaster.warning(
          'Email template not found. Please check.',
          'Warning',
          this.toasterConfig
        );
      }
    }
  } else if (label === 'SMS') {
    this.openSmsModal(docItem.slNo, docItem);
  } else if (label === 'Email/SMS') {
    this.selectedDocItem = docItem;
    this.emailCheckBoxDoc = docItem.isEmail;
    this.isSMSCheckedDoc = !!docItem.SmsContent;
    this.emailsmsmodalRef = this.modalService.show(
      this.documentemailsmspopup, 
      { class: 'custom-modal modal-dialog-centered' }
    );
  }
}
     disabledOkButton(){
    if(this.transactionType != 43){
      if(this.btndisable || (this.printform.form.get('email').touched && !this.printform.form.get('email').valid && this.enableEmail) || (!this.emailBox && this.enableEmail)){
        return  true;
      }else{
        return false;
      }
    }else{
      if(this.btndisable || (!this.emailBox && this.enableEmail)){
        return  true;
      }else{
        return false;
      }
    }
  }

  setEmailIdAndCellPhoneNumber() {
    if (this.isfrombatchletters || this.data.isWalkinCustomer) {
      this.emailBox = '';
      this.phoneNumber = '';
      if (this.data.isWalkinCustomer) {
        this.isWalkInCustomer = true;
      }
    } else {
      if (this.tenantId) {
        this.prospectsService.getContactInfo(this.tenantId).subscribe((response: IProspectContactInfo) => {
          if (response) {
            this.emailBox = response.BusinessAccount && response.CompanyEmail ? response.CompanyEmail : response.Email;
            if (response.NoEmail) {
              this.companySettingDetails = this.userSessionService.InServiceGetCompanySettings();
              this.emailBox = this.companySettingDetails.General.GenericCustomerEmailAddress;
            }
            this.emailAndSmsBox = this.emailBox;
            this.emailAndSmsBoxPhoneNumber = response.CellPhoneNumber;
            this.sendEmailForm.get("toAddress").setValue(this.emailBox);
            
            this.phoneNumber = response.CellPhoneNumber;
            this.sendSMSAlert = response.SendSMSAlerts;
            if (response.SendSMSAlerts && response.CellPhoneNumber) {
              this.isSmsDisabled = false;
            }
          }
        });
      } else {
        this.emailBox = '';
        this.phoneNumber = '';
      }
    }
  }

  duplicateDocumentRetryReq(model, count, isUnsignedDoc, slNo, templateId,obtainSignature?) {
    count = count + 1;
    let maxTime = (this.apiMaxWaitTime * 60) / this.apiStatusInterval;
    if (count <= maxTime) {
        this.documentService.GetGenerateTenantDocumentStatus(model).subscribe((response: any) => {
          if (response && response.Success || count == maxTime) {
            this.unsubscribeSelectedDuplicateRequest(model, slNo);
            if (!isUnsignedDoc) {
              let docObject = this.documentList.find(o => o.slNo == slNo);
              if (response.Success) {
                this.loaderIcon = Promise.resolve(false);
                this.documentList.find(o => o.slNo == slNo).disableSelect = true;
                if (docObject) {
                  docObject.blobUrl = response.BlobURL;
                  docObject.Processed = true;
                  docObject.isDefault = true;
                  docObject.isDocumentSuccess = true;
                  docObject.select = !docObject.select ? true : docObject.select;
                  this.toaster.success('Document Processed Successfully!', 'Success', this.toasterConfig);
                }
                this.documentList.map((item) => {
                  if (item.TemplateId == 28 && item.LetterId !== docObject.LetterId && this.IsFromManualInvoice) {
                    item.Processed = docObject.Processed;
                    item.isDefault = docObject.isDefault;
                    item.isDocumentSuccess = docObject.isDocumentSuccess;
                    item.select = docObject.select;
                    item.disableSelect = docObject.disableSelect;
                  }
                });
                if (docObject && response.TenantLettersAndNoticesAlternates && response.TenantLettersAndNoticesAlternates.length) {
                  docObject['AlternateLetterIds'] = response.TenantLettersAndNoticesAlternates.map((ele) => ele.TenantLettersAndNoticesAlternatesId);
                }
                if (docObject) {
                  docObject['TenantLettersAndNoticesIds'] = response.Id;
                }
                this.emitgoToHostforEditInfoDoc.emit(this.leaseNo);
              } else {
                this.loaderIcon = Promise.resolve(false);
                this.documentList.find(o => o.slNo == slNo).disableSelect = true;
                docObject.isDocumentFailed = true;
                this.documentList.map((item) => {
                  if (item.TemplateId == 28 && item.LetterId !== docObject.LetterId && this.IsFromManualInvoice) {
                    item.isDocumentFailed = docObject.isDocumentFailed;
                    item.disableSelect = docObject.disableSelect;
                  }
                });
                docObject.select = !docObject.select ? true : docObject.select
                this.toaster.error('Failed to process document!', 'Failure', this.toasterConfig);
                this.isDocGenerationfailed = true
              }
              if (this.bulkProcess) {
                this.checkBulkProcessCompletion();
              } else {
                this.loaderIcon = Promise.resolve(false);
              }
            } else {
              this.loaderIcon = Promise.resolve(false);
              let templetterIds = { LetterId: 0 }
              templetterIds.LetterId = model.LettersAndNoticesId;
              let tempTemplateId = templateId;
              let tempSlNo = slNo;

              let docObject = this.documentList.find(o => o.slNo == slNo);
              let currentLeaseNumber = model.LeaseNumber;
              let currentFacilityId = model.FacilityId ? model.FacilityId : this.facilityId;
              if (docObject) {
                if (this.eSignatureType !== 563) {
                  docObject.blobUrl = response.Success ? response.BlobURL : docObject.blobUrl;
                }
                currentLeaseNumber = docObject.leaseNo ? docObject.leaseNo : model.LeaseNumber;
                currentFacilityId = docObject.facilityId ? docObject.facilityId : model.FacilityId;
              }
              this.documentResponse = response;
              if (response.Success) {
                if (this.eSignatureType === 563) {
                  let rSignObj = {
                    Id: response.Id,
                    LetterId: templetterIds.LetterId,
                    SlNo: tempSlNo,
                    SigningUrl: response.SigningUrl,
                    EnvelopeCode: response.EnvelopeCode,
                    EnvelopeId: response.EnvelopeId
                  };
                  this.leaseDocumentResponse.push(rSignObj);
                }

                let lettersAndNoticesObj = {
                  Id: response.Id,
                  LetterId: templetterIds.LetterId,
                  SlNo: tempSlNo,
                  TemplateId: tempTemplateId
                }
                let index = this.tenantLettersAndNoticesIdsForEsignature.findIndex((ele) => ele.SlNo == tempSlNo)
                if (index == -1) {
                  this.tenantLettersAndNoticesIdsForEsignature.push(lettersAndNoticesObj); // required to delete the sample lease agreement
                } else {
                  this.tenantLettersAndNoticesIdsForEsignature[index] = lettersAndNoticesObj;
                }
                let leaseObj = {
                  LetterId: model.LettersAndNoticesId,
                  BlobURL: response.BlobURL,
                  SlNo: tempSlNo,
                }
                let index2 = this.leaseBloBURLs.findIndex((item) => item.LetterId == model.LettersAndNoticesId && item.SlNo == tempSlNo);
                if (index2 == -1) {
                  this.leaseBloBURLs.push(leaseObj);
                } else {
                  this.leaseBloBURLs[index] = leaseObj;
                }
                if (obtainSignature && !this.onEmailFlag && !this.onSmsFlag) {
                  this.sendForESignature(model.LettersAndNoticesId, templateId, null, leaseObj.BlobURL, model.letterType, slNo, response.LeaseNo,
                    response.ReceiptId, response.ESignatureId, docObject.tenantId, model.LedgerId);
                }

                if (response.ESignatureId && response.ESignatureId > 0) {
                  let obj = {
                    LetterId: model.LettersAndNoticesId,
                    ESignatureId: response.ESignatureId
                  }
                  this.eSignatureIds.push(obj)
                }

                if (this.onApproveFlag) {
                  this.processDocument(slNo);
                } else if (this.onEmailFlag) {
                  if (this.tenantLettersAndNoticesIdsForEsignature && this.tenantLettersAndNoticesIdsForEsignature.length > 0) {
                    this.getEmailBody(slNo, obtainSignature.LeaseNumber);
                    this.currentDocument['LeaseNo'] = response.LeaseNo;
                    this.slNumber = slNo;
                    this.documentList.forEach(element => {
                      if (element.slNo == slNo) {
                        element['unsignedDocGenerated'] = true
                      }
                    });
                    this.modalRef = this.modalService.show(this.esignatureModal, { class: 'modal-lg modal-dialog-centered' });
                  } else {
                    this.modalRef.hide();
                    this.toaster.warning('Email template not found. Please check.', 'Warning', this.toasterConfig);
                  }
                }
              }
              else {
                const document = this.documentList.find(e => e.slNo == slNo);
                if (document) document.isDocumentFailed = true;
                this.onApproveFlag = false;
              }
            }
          }
        }, err => {
          this.unsubscribeSelectedDuplicateRequest(model, slNo);
          this.toaster.warning('Duplicate Request Submitted. Please verify manually if your request has been completed', 'Alert', this.toasterConfig);
          this.loaderIcon = Promise.resolve(false);
          this.bulkProcess = false;
        });
    } else {
      this.unsubscribeSelectedDuplicateRequest(model, slNo);
        this.toaster.warning('Duplicate Request Submitted. Please verify manually if your request has been completed', 'Alert', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.bulkProcess = false;
    }
}

addSubscriptionDuplicateRequest(model, slNo) {
  const source = interval(this.apiStatusInterval * 1000);
  const duplicateDocumentRequest = source.subscribe(val => this.duplicateDocumentRetryReq(model, val, false, slNo,0,null));
  const SubObject = {
    Subscription: duplicateDocumentRequest,
    model: model,
    slNo: slNo
  };
  this.duplicateDocumentRequestList.push(SubObject);
}
unsubscribeSelectedDuplicateRequest(model, slNo) {
  if (this.duplicateDocumentRequestList.length) {
    let subscriptionModel = this.duplicateDocumentRequestList.find(req => req.slNo = slNo && req.model.TransactionTypeId == model.TransactionTypeId &&
     req.model.LeaseNumber == model.LeaseNumber && req.model.FacilityId == model.FacilityId && req.model.LettersAndNoticesId == model.LettersAndNoticesId
     && req.model.ReceiptId == model.ReceiptId && req.model.InvoiceId == model.InvoiceId
    );
    subscriptionModel.Subscription.unsubscribe();
  }
}
  isEmailCheckBoxDisabled() {
    return ((!this.isWalkInCustomer && this.emailBox == '') || (this.emailTemplates?.length === 0 && this.ReservationNumber));
  }  
  getButtonLabel(docItem){
  if (docItem.isEmailTemplateDefined && docItem.isSMSTemplateDefined) {
    return 'Email/SMS';
  } if (docItem.isEmailTemplateDefined && (!docItem.isSMSTemplateDefined || !this.sendSMSAlert)) {
   return 'Email';
  } if (!docItem.isEmailTemplateDefined && docItem.isSMSTemplateDefined) {
    return 'SMS';
  }
  return 'Email';
}

onButtonClick(docItem) {
  const label = this.getButtonLabel(docItem);
  
  switch(label) {
    case 'Email':
      this.openEsignatureModal(docItem.slNo, docItem);
      break;
      
    case 'SMS':
      this.openSmsModal(docItem.slNo, docItem);
      break;
      
    case 'Email/SMS':
      this.selectedDocItem = docItem;
      this.emailAndSmsflag = true;
      this.emailsmsmodalRef = this.modalService.show(
        this.documentemailsmspopup, 
        { class: 'custom-modal modal-dialog-centered' }
      );
      break;
  }
}

sendEmailandsms(event: { email: string, phone: string, emailSelected: boolean, smsSelected: boolean }) {
  this.emailAndSmsBox  = event.email;
  this.emailAndSmsBoxPhoneNumber = event.phone;
  this.emailCheckBoxDoc = event.emailSelected;
  this.isSMSCheckedDoc = event.smsSelected;
   this.processSendOrResend(); 
}
sendMessageWithBody(messageBody: string) {
    this.onSmsFlag = false;
    this.countryCode = this.countryCode ?? "1";
    this.fullNumber = '+' + this.countryCode + this.emailAndSmsBoxPhoneNumber?.trim();
    const phoneNumberArr = [this.fullNumber];
    const messages = [{
        FromPhoneNumber: null,
        ToPhoneNumberList: phoneNumberArr,  
        Message: messageBody,
        TenantPhoneNumber: null,
        MessageStatus: 'sent',
        ErrorCode: null,
    }];
   const smsRequest = {
        LocationId: this.facilityId,
        AccountID: null,
        Token: null,
        ServiceId: 0,
        LeaseNumber: this.currentDocument?.leaseNo ?? this.leaseNo,
        FacilityId: this.facilityId,
        ReservationNumber: this.ReservationNumber || null,
        ReservationFacilityId: null,
        InquiryNumber: null,
        InquiryFacilityId: null,
        TenantId: this.tenantId,
        TransactionTypeId: this.currentDocument.LeaseNo? ETransactionTypes.Move_In : 
                        this.ReservationNumber? ETransactionTypes.Reservation : 
                        this.transactionType? this.transactionType : null,
        SentSuccessfully: true,
        SMSCampaignId: null,
        SMSList: messages,
        ProspectItemType: this.facOpsDataService.ProspectItemType,
        ConfirmationNumber: this.facOpsDataService.confirmationNumberForMessege,
    };

      this.twoWayService.SendSms(smsRequest).subscribe((response: ISendSmsResponse) => {
      if (response.Success) {
        this.documentList.map(o => {
          if (o.slNo === this.slNumber) {
            o.isSmsSuccess = true;
            o.isDocumentSuccess = true;
            o.select = !o.select ? true : o.select
            o.isApprove = false;
            o.disableSelect = true;
          }
        });
        this.toaster.success('SMS Sent Successfully', 'Success', this.toasterConfig);
      }else {
          this.toaster.error('Failed to Send SMS', 'Failure', this.toasterConfig);
        }
      });
}
  processSendOrResend() {
  const isEmailSelected = this.emailCheckBoxDoc;
  const isSmsSelected = this.isSMSCheckedDoc; 

    if (isEmailSelected && isSmsSelected) {
    let obj = this.documentList.find(item => item.slNo == this.selectedDocItem.slNo);

    this.currentDocument = this.selectedDocItem;
    this.slNumber = this.selectedDocItem.slNo;
    this.onEmailFlag = true;
    this.onSmsFlag = true;

    this.changeDocument(
      obj.LetterId,
      this.slNumber,
      this.selectedDocItem.TemplateId,
      this.onApproveFlag,
      this.onEmailFlag,
      this.onSmsFlag
    );
  } else if (isEmailSelected) {
    this.openEsignatureModal(this.selectedDocItem.slNo, this.selectedDocItem);
  } else if (isSmsSelected) {
    this.openSmsModal(this.selectedDocItem.slNo, this.selectedDocItem);
  }
  if (this.emailsmsmodalRef) {
    this.emailsmsmodalRef.hide();
  }
}

}
